import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";

import { ApiClient } from "../api-client";

import type { SearchResponse } from "../generated-api";

type SearchLessonQueryParams = {
  index: string;
  phrase: string;
  schoolClasses?: string[];
  subjects?: string[];
};

export const searchLessonQueryOptions = (queryParams: SearchLessonQueryParams) =>
  queryOptions({
    queryKey: ["searchLesson", queryParams],
    queryFn: async () => {
      const response = await ApiClient.api.opensearchControllerSearch({
        index: queryParams.index,
        phrase: queryParams.phrase,
        ...(queryParams.schoolClasses && { schoolClasses: queryParams.schoolClasses }),
        ...(queryParams.subjects && { subjects: queryParams.subjects }),
      });
      return response.data;
    },
    select: (data: SearchResponse) => data,
    enabled: Boolean(queryParams.phrase),
  });

export function useSearchLessonQueryOptions(queryParams: SearchLessonQueryParams) {
  return useQuery(searchLessonQueryOptions(queryParams));
}

export function useSearchLessonQueryOptionsSuspense(queryParams: SearchLessonQueryParams) {
  return useSuspenseQuery(searchLessonQueryOptions(queryParams));
}

export const searchHistoryQueryOptions = (index: string, options?: { enabled?: boolean }) =>
  queryOptions({
    queryKey: ["searchHistory", index],
    queryFn: async () => {
      const response = await ApiClient.api.opensearchControllerSearchHistory();
      return response.data;
    },
    select: (data: SearchResponse) => data.data,
    enabled: options?.enabled,
  });

export function useSearchHistory(index: string, options?: { enabled?: boolean }) {
  return useQuery({
    ...searchHistoryQueryOptions(index),
    enabled: options?.enabled,
  });
}

export function useSearchHistorySuspense(index: string) {
  return useSuspenseQuery(searchHistoryQueryOptions(index));
}
